module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_6000.3e3f46ab.png";